import './MuiClassNameSetup'
import CartRoutes from './Routes'
import { BrowserRouter } from 'react-router-dom'
import { lightTheme } from './styles'
import { ThemeProvider } from '@mui/material/styles'
import { useCookies } from 'react-cookie'
import getLanguageMessages from './services/getLanguageMessages'
import { IntlProvider } from 'react-intl'
import NotificationEvents from './components/NotificationEvents'

function App() {
  const [cookies] = useCookies(['language'])
  const messages = getLanguageMessages(cookies.language)

  return (
    <IntlProvider locale={cookies.language ? cookies.language : 'en'} messages={messages}>
      <BrowserRouter>
        <ThemeProvider theme={lightTheme}>
          <NotificationEvents>
            <CartRoutes />
          </NotificationEvents>
        </ThemeProvider>
      </BrowserRouter>
    </IntlProvider>
  )
}

export default App
